import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import { JobServicesService } from 'src/app/services/job-services.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { BreadcrumbService   } from 'xng-breadcrumb';
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.css'],
    providers: [MessageService],
    standalone: false
})
export class UserListComponent implements OnInit, OnDestroy {
  private unsub$: Subject<void> = new Subject<void>()
  private sortSubject: Subject<any> = new Subject();

  loadingSpinner: boolean = false;
  showFilterSidebar: boolean = false;
  showDownloadSidebar: boolean = false;
  displaySaveFilterSettings: boolean = false;
  addUserSlider: boolean = false;
  adminAccess: boolean = true;

  usersList: any = [];
  usersCol: Array<any> = [];
  _usersCol: Array<any> = [];
  colsToDownload: Array<any> = [];
  pageLimits: Array<any> = [];
  checkedColumns: Array<any> = [];
  selectedUsers: Array<any> = [];
  userTypes: any = {};
  userData: any = null;
  userPrivileges: Set<string> = new Set();

  first: number = 1;
  last: number = 10;
  pageSize: number = 10;
  pageNumber: number = 1;
  totalLength: number = 0;
  totalPages: number = 1;

  order_by: string = 'asc';
  sort_by: string = 'id';
  downloadSearchTerm: string = '';
  downloadAs: string = 'excel';
  exportName: string = 'userList';
  privilege: any = {};

  @Input() addUser$: Subject<void> = new Subject<void>();
  searchForm!: FormGroup;
  searchUnSub$: Subject<void> = new Subject<void>();

  selectAllColumnsForDownload: boolean = true;

  constructor(private jobServices: JobServicesService, private messageService: MessageService, private globalService: GlobalServicesService, private breadcrumbService: BreadcrumbService, private fb: FormBuilder, private confirmationService: ConfirmationService, private cdr: ChangeDetectorRef  ) {
    this.pageLimits = [10, 25, 50, 100];
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });
    this.usersCol = [
      { index: 1, field: 'first_name', header: 'First Name' },
      { index: 2, field: 'last_name', header: 'Last Name' },
      { index: 3, field: 'role_name', header: 'Associated Role' },
      { index: 4, field: 'email', header: 'Official Email ID' },
      { index: 5, field: 'is_active', header: 'Status' },
      { index: 6, field: 'is_sso_user', header: 'SSO User' },
      { index: 7, field: 'mobile_number', header: 'Mobile Number' },
    ]

    this.userTypes = {
      superAdmin: 'Super Admin',
      admin: 'Admin',
      user: 'User',
      recruiter: 'Recruiter',
      hiringManager: 'Hiring Manager',
      limitedRecruiter: 'Limited Recruiter',
      interviewer: 'Interviewer',
      evaluator: 'Evaluator'
    }
  }

  ngOnInit(): void {
    this._usersCol = this.usersCol
    this.colsToDownload = this.usersCol;
    this.checkedColumns = this.usersCol;
    if (this.userPrivileges.has('user.view')) {
      this.getAllUsers();
    }
    
    this.sortSubject.pipe(debounceTime(300)).subscribe(event => {
      this.sort_by = event.field;
      this.order_by = event.order === 1 ? 'asc' : 'desc';
      this.getAllUsers(); 
    });

    this.addUser$.pipe(takeUntil(this.unsub$)).subscribe(() => {
      this.userData= null;
      this.addUserSlider = true;
    })

    this.searchForm = this.fb.group({
      search: [""]
    })
    this.searchForm.get("search")?.valueChanges.pipe(takeUntil(this.unsub$), debounceTime(300), distinctUntilChanged()).subscribe((search) => {
      this.searchUnSub$.next();
      this.pageNumber = 1;
      this.getAllUsers(search);
    })
  }

  ngOnDestroy(): void {
    this.unsub$.next();
    this.unsub$.complete();
  }



  getAllUsers(search = "") {
    this.loadingSpinner = true;
    this.usersList = [];
    this.jobServices.getUsersFastApi(this.pageNumber, this.pageSize, this.order_by, this.sort_by, search).pipe(takeUntil(this.searchUnSub$)).subscribe({
      next: (response: any) => {
        this.usersList = Object.keys(response.body.items).length !== 0 ? response.body.items : [];
        this.usersList.forEach((each: any) => {
          each.role_name = each.role? each.role.name : ' - ';
        });
        this.totalLength = response.body.total || 0;
        this.first = response.body.page || 1;
        this.last = response.body.pages || 10;
        this.pageSize = response.body.size || 10;
        this.totalPages = response.body.pages || 1;
        this.loadingSpinner = false;
      },
      error: () => {
        this.loadingSpinner = false; // Handle error case
      }
    });
  }

  getUsersByLimit = () => {
    this.showFilterSidebar = false;
    this.showDownloadSidebar = false;
    this.pageNumber = 1;
    this.first = 1;
    this.getAllUsers(this.searchForm.get("search")?.value || "");
  };

  openUser(user: any) {
    this.userData = user;
    this.userData.isUpdate = true;
    this.addUserSlider = true;
  }

  editUser(user: any) {
    this.userData = {
      ...user,
      isUpdate: true,
      role_id: user.role?.id || null
    };
    this.addUserSlider = true;
    this.selectedUsers = [];
  }
  downloadHide(){
    this.downloadSearchTerm = '';
    this.colsToDownload = this.usersCol;

    this.checkedColumns = this.usersCol;
    this.selectAllColumnsForDownload = this.checkedColumns.length === this.colsToDownload.length;
    this.cdr.detectChanges();
  }

  searchColumns = (searchTerm: string) => {
    if (this.showDownloadSidebar) {
      this.colsToDownload = this.usersCol.filter(val => val.header.toLowerCase().includes(searchTerm.toLowerCase()));
    }
  }
  async deleteUserConfirmation(user: any, event: any) {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-exclamation-triangle',
      accept: async () => { // Mark this function as async
        this.loadingSpinner = true;
        await this.deleteUser(user);
      },
      reject: () => {
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Rejected',
        //   detail: 'You have rejected',
        // });
      },
    });
  }
  public deleteUser = (user: any) => {
    this.jobServices.deleteUserFastApi(user.id.toString()).subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: res.body.detail });
          this.selectedUsers = [];
          this.getAllUsers(this.searchForm.get("search")?.value || "");
        }
        this.loadingSpinner = false;
      },
      error: (_err: any) => {
        this.loadingSpinner = false;
      }
    });
  }
  onSelectedUserChange = (event: any) =>{
    this.selectedUsers = event;
  }

  exportUser = (type: string) => {
    let checkedColumnFields: any = [];
    this.checkedColumns.forEach((each) => {
      checkedColumnFields.push(each);
    });
    let afterFilter: any = [];
    const usersToExport = this.selectedUsers.length > 0 ? this.selectedUsers : this.usersList;
    usersToExport.forEach((eachData: any) => {
      let filterData: any = {};
      checkedColumnFields.forEach((item: any) => {
        eachData.hasOwnProperty(item.field) && (filterData[item.header] = eachData[item.field]);
      });
      if (
        checkedColumnFields.find((element: any) => element.field === 'location')
      ) {
        let locationString: string = '';
        eachData.locationInformation.forEach((eachlocation: any) => {
          locationString +=
            `${locationString.length ? ', ' : ''}` + eachlocation.location;
        });
        filterData['location'] = locationString;
      }
      afterFilter.push(filterData);
    });
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(afterFilter);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: type === 'excel' ? 'xlsx' : 'csv', type: 'array' });
      this.saveAsExcelFile(excelBuffer, this.exportName, type);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string, type: string): void {
    let FILE_TYPE =
      type === 'excel'
        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        : 'text/csv';
    let FILE_EXTENSION = type === 'excel' ? '.xlsx' : '.csv';
    const data: Blob = new Blob([buffer], {
      type: FILE_TYPE,
    });
    saveAs(data, fileName + '_export_' + new Date().getTime() + FILE_EXTENSION);
  }

  next(): void {
    this.showFilterSidebar = false;
    this.showDownloadSidebar = false;
    this.first = this.first + this.pageSize;
    this.last = this.last + this.pageSize < this.totalLength ? this.pageSize + this.last : this.totalLength;
    this.pageNumber += 1;
    this.getAllUsers();
  }

  prev(): void {
    this.showFilterSidebar = false;
    this.showDownloadSidebar = false;
    this.first = this.first - this.pageSize;
    this.last = this.last - this.pageSize > this.pageSize ? ( this.last == this.totalLength ? this.totalLength - this.usersList.length : this.last - this.pageSize ) : this.pageSize;
    this.pageNumber -= 1;
    this.getAllUsers();
  }

  isLastPage(): boolean {
    return this.pageNumber === this.totalPages;; 
  }

  isFirstPage(): boolean {
    return this.first === 1;
  }
  onSort(event: any) {
    if (this.sort_by !== event.field || this.order_by !== (event.order === 1 ? 'asc' : 'desc')) {
      this.sort_by = event.field;
      this.order_by = event.order === 1 ? 'asc' : 'desc';
      this.getAllUsers();
    }
  }

  onUserAdded(message: any) {
    this.addUserSlider = false;
    this.userData = null;
    this.getAllUsers();
    if(message) {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: message });
    }
  }

  onUserUpdated(message: any) {
    this.addUserSlider = false;
    this.userData = null;
    this.getAllUsers(this.searchForm.get("search")?.value || '');
    if(message) {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: message });
    }
  }

  // Calculate dynamic height for download sidebar content
  getDownloadContentHeight(): string {
    // Table height is 75vh (from scrollHeight="75vh")
    // Subtract approximate heights for:
    // - sidebar title: ~40px
    // - search input: ~40px  
    // - download container: ~120px
    // - some padding/margins: ~20px
    const tableHeight = 75; // 75vh
    const sidebarTitleHeight = 2.5; // ~40px in vh
    const searchInputHeight = 2.5; // ~40px in vh
    const downloadContainerHeight = 7.5; // ~120px in vh
    const paddingMargin = 1.25; // ~20px in vh
    
    const calculatedHeight = tableHeight - sidebarTitleHeight - searchInputHeight - downloadContainerHeight - paddingMargin;
    
    return `${Math.max(calculatedHeight, 20)}vh`; // Minimum 20vh
  }

  toggleSelectAll(): void {
    if (this.selectAllColumnsForDownload) {
      this.checkedColumns = [...this.colsToDownload];
    } else {
      this.checkedColumns = [];
    }
    this.selectAllColumnsForDownload = this.checkedColumns.length === this.colsToDownload.length;
    this.cdr.detectChanges();
  }

  onColumnCheckChange(): void {
    this.selectAllColumnsForDownload = this.checkedColumns.length === this.colsToDownload.length;
    this.cdr.detectChanges();
  }

  isColumnCheckedForDownload(field: any) {
    return this.checkedColumns?.includes((che: any) => che.field === field);
  }
}
